module.exports = __webpack_public_path__ + "static/media/sash-window.bf31d9ab.mtl";